import request from '../utils/request.js'

// 获取分类列表
export function getCategoryList () {
  return request({
    url: '/api/v1/admin/category/list',
    method: 'get'
  })
}

// 新增/编辑分类
export function saveCategory (data) {
  return request({
    url: '/api/v1/admin/category/save',
    method: 'post',
    data
  })
}

// 删除分类（仅支持单个）
export function deleteCategory (id) {
  return request({
    url: '/api/v1/admin/category/delete',
    method: 'post',
    data: [id]
  })
}

// 分类图片上传
export function uploadCategoryImage (formData) {
  return request({
    // 复用后端公共图片上传
    url: '/api/v1/upload/image',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}




// WEBPACK FOOTER //
// ./src/api/category.js